import $ from 'jquery';
import TomSelect from 'tom-select/dist/js/tom-select.complete.min.js';

let fieldsAreInitialized = false;

function initSelects() {
  const selects = document.querySelectorAll(
    'select.custom-select, .gform_wrapper select, .variations_form select, .woocommerce-ordering select, .facetwp-type-sort select'
  );

  if (0 < selects.length) {
    selects.forEach((select) => {
      new TomSelect(select, {
        create: false,
        render: {
          option: (data, escape) => {
            return (
              '<div class="option"><span>' + escape(data.text) + '</span></div>'
            );
          },
        },
      });
    });
  }
}

function changeFormLabel(label, input) {
  if ('' !== input.value) {
    label.classList.add('active');
  }

  label.addEventListener('click', function () {
    input.focus();
  });

  input.addEventListener('focus', function () {
    label.classList.add('active');
  });

  input.addEventListener('focusout', function () {
    if (!input.value || '(___) ___-____' === input.value) {
      label.classList.remove('active');
    }
  });
}

function addFormEvents() {
  const fields = document.querySelectorAll('.gfield');

  if (0 < fields.length) {
    fields.forEach(function (field) {
      if (field.classList.contains('initialized')) {
        return;
      }

      const classesExcluded = [
        'gfield--radio',
        'gfield--checkbox',
        'gfield--consent',
        'gfield--select',
      ];

      for (let i = 0; i < classesExcluded.length; i++) {
        if (field.classList.contains(classesExcluded[i])) {
          return;
        }
      }

      if (field.classList.contains('gfield--has-multiple-inputs')) {
        const subfields = field.querySelectorAll('.ginput_complex > span');

        if (0 < subfields.length) {
          subfields.forEach(function (subfield) {
            if (subfield.classList.contains('initialized')) {
              return;
            }
            subfield.classList.add('initialized');

            const sublabel = subfield.querySelector('label');
            const subinput = subfield.querySelector('input, textarea');
            if (subinput) {
              changeFormLabel(sublabel, subinput);
            }
          });
        }
      } else {
        field.classList.add('initialized');

        const label = field.querySelector('.gfield_label');
        const input = field.querySelector(
          '.ginput_container input , .ginput_container textarea'
        );

        if (label && input) {
          changeFormLabel(label, input);
        }
      }
    });
  }
}

function changeFileUpload() {
  const multiFileUploads = document.querySelectorAll(
    '.gform_fileupload_multifile'
  );
  if (0 < multiFileUploads.length) {
    multiFileUploads.forEach(function (fileUpload) {
      fileUpload.querySelector('.gform_drop_instructions').textContent =
        wp.i18n._x(
          'Drag and drop file to upload',
          'drag and drop instruction',
          'vtx'
        );
    });
  }
}

$(document).on('gform_post_render', function () {
  if (!fieldsAreInitialized) {
    changeFileUpload();
    addFormEvents();
    initSelects();
  }
  fieldsAreInitialized = true;
});

// ON READY
window.addEventListener('load', function () {
  if (!fieldsAreInitialized) {
    changeFileUpload();
    addFormEvents();
    initSelects();
  }
  fieldsAreInitialized = true;
});
